let fallbackSequence = 0;

const generateKey = (prefix) => {
    if (typeof window !== "undefined" && typeof window.crypto?.randomUUID === "function") {
        return `${prefix}-${window.crypto.randomUUID()}`;
    }

    fallbackSequence += 1;
    return `${prefix}-fallback-${fallbackSequence}`;
};

export const createIdempotencyRecord = (prefix, fingerprint) =>
    Object.freeze({key: generateKey(prefix), fingerprint: String(fingerprint)});

export const refreshIdempotencyRecord = (record, fingerprint, prefix) =>
    record?.fingerprint === String(fingerprint)
        ? record
        : createIdempotencyRecord(prefix, fingerprint);
